/**
 * @generated SignedSource<<b31904c5b89beeaf304d128f4866f95d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AgendaBuilderTone = "CASUAL" | "FORMAL" | "NEUTRAL";
export type agendaBuilderSettingsQuery$variables = {
  streamId: string;
};
export type agendaBuilderSettingsQuery$data = {
  readonly stream: {
    readonly agendaBuilderContext?: string;
    readonly agendaBuilderTone?: AgendaBuilderTone;
  } | null;
};
export type agendaBuilderSettingsQuery = {
  response: agendaBuilderSettingsQuery$data;
  variables: agendaBuilderSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "streamId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "streamId"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agendaBuilderTone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agendaBuilderContext",
      "storageKey": null
    }
  ],
  "type": "NoteStream",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "agendaBuilderSettingsQuery",
    "selections": [
      {
        "alias": "stream",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "agendaBuilderSettingsQuery",
    "selections": [
      {
        "alias": "stream",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f7e5d7f7bb6dacb8431dcf7515aa4f0c",
    "id": null,
    "metadata": {},
    "name": "agendaBuilderSettingsQuery",
    "operationKind": "query",
    "text": "query agendaBuilderSettingsQuery(\n  $streamId: ID!\n) {\n  stream: node(id: $streamId) {\n    __typename\n    ... on NoteStream {\n      agendaBuilderTone\n      agendaBuilderContext\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2fd8d0f03dab1aa4d58a98dbbaac0d96";

export default node;
